//
// config__frontend.js
//
const config = {
  googleAdsBaseUrl: "https://ads.google.com/aw",
  updateWebhooksUrl: window.config && window.config.updateWebhooksUrl
};

module.exports = config;
